import { Lang } from 'vuejs-localization';

class GameLocalisation {
    constructor(private readonly $lang: Lang) {}

    public getLocalGameName(gameName: string, skinName?: string): string {
        if (this.$lang.game.gameNameTranslations) {
            if (this.$lang.game.gameNameTranslations[gameName.toLowerCase()]) {
                gameName = this.$lang.game.gameNameTranslations[gameName.toLowerCase()];
            }
        }
        if (skinName && this.$lang.game.arcade.acceptedSkins) {
            skinName = this.$lang.game.arcade.acceptedSkins[skinName.toLowerCase()] ? this.$lang.game.arcade.acceptedSkins[skinName.toLowerCase()] : null;
        }
        if (skinName) {
            return this.$lang.game.arcade.gameNameFormat.format({
            gameName,
            skinName
            });
        }
        return gameName;
    }
}

export { GameLocalisation };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/modules/game-localisation/game-localisation.ts